import 'core-js/stable';

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import FrontLayout from '@/components/layout/FrontLayout.vue'
import DefaultLayout from '@/components/layout/DefaultLayout.vue'
import EmptyLayout from '@/components/layout/EmptyLayout.vue'

Vue.config.productionTip = false
Vue.component('front-layout', FrontLayout)
Vue.component('default-layout', DefaultLayout)
Vue.component('empty-layout', EmptyLayout)

// ルーティング毎のフックでログイン画面へ
router.beforeEach(async (to, from, next) => {
  if ( to.matched.some(record => !record.meta.isPublic) ){
    const apiArgs = () => {
      if(to.meta && to.meta.apiOptions){
        return { __apiOptions: to.meta.apiOptions }
      }
      return { __apiOptions: { noErrorDialog: true } }
    }

    const checkResult = await store.dispatch('api/checkLoginKuraemonId', apiArgs());
    console.log(checkResult);
    if(!checkResult){
      // no loggedin
      next({ name: 'login', query: { redirect: to.fullPath }});
      return;
    }
  }
  // OK
  store.dispatch('view/start')
  next();
});

router.afterEach(() => {
  store.dispatch('view/end')
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
